import {message} from "ant-design-vue"

export default {
    data(){
        return {
            loading:false,
            dataSource:[],
            current:1,
            pageSize:20,
            total:0,
            modalinfo:{
                visible:false,
                title:"",
				width:"500px"
            },
            notNull:[],
            selectedRowKeys: [],
            selectedRows: [],
            tabledata:{},
            trRender:[]
        }
    },
    props:{
        columns: Array,
        request: Object,
        params: Object,
        rowKey:String,
        searchData:Object,
        formData:Object,
        mulselect:Boolean,
		saveinputs:Array,
		rowClassName:Function,
    },
    computed:{},
    mounted(){
        let {current,pageSize} = this
        this.getData({current,pageSize})
        this.columns.forEach(item=>{
            if(item.myRender ){
                return  this.trRender.push(item.myRender)
            }
        })
    },
	watch:{
		params:{
			handler(val,old){
				console.log(val)
			}
		}
	},
    methods:{
		changecolor(){
			return "bianhong"
		},
        muldelete(){
            let slts = this.selectedRowKeys
            if(slts.length == 0){
                message.error({
                    content:"请选择要删除的数据",
                    duration:1
                })
            }else{
                let {delets}  = this.request
                delets({ids:JSON.stringify(slts)}).then(()=>{
                    this.getSearchData()
                    message.success({
                        content:"删除成功",
                        duration:1
                    })
                    this.selectedRowKeys = []
                }).catch(()=>{
                    message.error({
                     content:"删除失败",
                     duration:1
                    })
                })
            }
        },
        onSelectChange(selectedRowKeys,selectedRows) {
            console.log('selectedRowKeys changed: ', selectedRowKeys);
            this.selectedRowKeys = selectedRowKeys;
			this.selectedRows = selectedRows
        },
		getselectrows(){
			return this.selectedRows
		},
		getselectrowkey(){
			return this.selectedRowKeys
		},
        showModal(title,notNull,width){
            this.modalinfo = {visible:true,title,width}
            this.notNull = notNull
        },
		pageSizeChange(current,size){
			this.pageSize = size
			this.current =1
			this.getData({current:1,pageSize:size})
		},
        pageChange(current,pageSize){
            this.current = current
            this.pageSize = pageSize
            this.getData({current,pageSize})
        },
		
        getSearchData(state=0){
			if(state == 0){
				this.current = 1
            	this.getData({current:1,pageSize:this.pageSize})
			}else{
            	this.getData({current:this.current,pageSize:this.pageSize})
			}
        },
		reloadtabledata(parm){
            this.getData({current:this.current,pageSize:this.pageSize,...parm})
		},
        getData(pagination){
            this.loading = true
            let {get} =  this.request
            get({...this.params,...pagination,...this.searchData}).then(ret=>{
                this.loading = false
                let {rows,count}= ret.data;
                this.dataSource = rows
                this.tabledata = ret.data
                this.total = count
            })
        },
	getDataSource(){
	   return this.dataSource
	},
	getsearchparm(){
	   return {...this.params,...this.searchData}
	},
        onOk(){
            let fd =this.formData,
	    {handleData} = this.request
            let {id} = fd
	    if(handleData){
	        fd = handleData(fd)
	    }
            if(id){
                this.updateData({...fd})
            }else{
                this.addData({...fd})
            }
        },
        checkData(data){
            let ret = true;
            this.notNull.find(item=>{
                if(!data[item["value"]]){
                    ret = false
                    message.error({content:`${item['text']}不能为空`});
                }
				if( data[item["value"]] && item["checkfn"]){
					ret = item["checkfn"](data[item["value"]])
					if(!ret){
						if(item["msg"]){
						}else{
                    		message.error({content:`请检查${item['text']}是否正确`});
						}
					}
				}
                return !ret;
            })
            return ret;
        },
        addData(data){
            if(!this.checkData(data)){
                return;
            }
            let {add} = this.request
            message.loading({content:"正在添加...",key:"addData"})
            add(data).then((ret)=>{
                this.modalinfo = {visible:false}
				if(ret.code == 0){
					message.success({content:"添加成功",key:"addData",duration:2})
				}else{
					message.error({content:ret.msg,key:"addData",duration:2})
				}
				this.getSearchData()
			})
        },
        updateData(data){
            if(!this.checkData(data)){
                return;
            }
            let {update} = this.request
            message.loading({content:"正在提交修改...",key:"updateData"})
            update(data).then((ret)=>{
                this.modalinfo = {visible:false}
				if(ret.code == 0){
					message.success({content:"修改成功",key:"updateData",duration:2})
				}else{
					message.error({content:ret.msg,key:"updateData",duration:2})
				}
				this.getSearchData()
				})
        },
        showDelConfirm(){
            this.$confirm({
                title:"操作确认提示",
                content:"您确定要删除该数据",
                okText:"确定",
                cancelText:"取消",
                onOk:()=>{
                    this.deleteData()
                }
            })
        },
        deleteData(){
            let { delet } = this.request
            let {id } = this.formData
            message.loading({content:"正在删除...",key:"updateData"})
            delet({id}).then(()=>{
                this.modalinfo = {visible:false}
                this.getSearchData()
                message.success({content:"删除成功",key:"updateData",duration:2})
            }) 
        }
    }
}